import React, { useState } from 'react';
import { Icon, Typography, Button, ButtonMenu } from '@ann/web-components';
import { 
  UsersListContainerInternal, 
  UsersListContainerExternal,
  UsersListScrollWrapper,
  UserItem, 
  UserInfo, 
  UserActions,
  CollapsibleContainer, 
  CollapsibleHeader, 
  HeaderContent, 
  IconContainer 
} from './ShareKnowledgeModal.styled';
import { NameInitialsAvatar } from 'react-name-initials-avatar';

const CurrentUsersList = ({
  shouldShow,
  currentUsers,
  isLoading,
  privileges,
  onUpdatePermission,
  onRemove
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!shouldShow) return null;

  return (
    <CollapsibleContainer>
      <CollapsibleHeader onClick={() => setIsOpen(!isOpen)}>
        <HeaderContent>
          <Typography category="subtitle" size="small" weight="bold" color="subtitle">
            View who has access
          </Typography>
          <Typography category="body" size="medium" weight="regular" color="body">
            {currentUsers.length} {currentUsers.length === 1 ? 'user' : 'users'} currently have access
          </Typography>
        </HeaderContent>
        <IconContainer>
          <Icon
            name={isOpen ? "chevronUp" : "chevronDown"}
            size={24}
            color="secondary"
          />
        </IconContainer>
      </CollapsibleHeader>

      {isOpen && (
        <UsersListScrollWrapper>
          <UsersListContainerExternal>
            <UsersListContainerInternal>
              {isLoading ? (
                <Typography category="body" size="medium" color="secondary">
                  Loading...
                </Typography>
              ) : currentUsers.length === 0 ? (
                <Typography category="body" size="medium" color="secondary">
                  No users have access yet
                </Typography>
              ) : (
                currentUsers.map((user) => (
                  <UserItem key={user.grantee_uuid}>
                    <UserInfo>
                      <NameInitialsAvatar
                        name={user.grantee_name}
                        bgColor="#2563eb"
                        textColor="#ffffff"
                        size="24px"
                        borderRadius="50%"
                        textWeight="bold"
                        textSize="12px"
                        borderColor="#ffffff"
                        borderStyle="solid"
                        borderWidth="2px"
                      />
                      <Typography
                        category="body"
                        size="medium"
                        weight="regular"
                        color="body"
                      >
                        {user.grantee_name} {user.grantee_email}
                      </Typography>
                    </UserInfo>
                    <UserActions>
                      <ButtonMenu
                        iconPosition="right"
                        label={user.privileges[0]?.privilege_name || 'Permission'}
                        menuPosition="bottom"
                        onChange={(value) => onUpdatePermission(
                          user.grantee_uuid,
                          user.grantee_type,
                          value
                        )}
                        size="medium"
                        pill={true}
                        type="secondary"
                        className="list-actions"
                        width="auto"
                        usePortal={true}
                        disableEffects={true}
                      >
                        <ButtonMenu.Menu>
                          {privileges.knowledgeBasePrivileges.map((privilege) => (
                            <ButtonMenu.Item
                              key={privilege.entityPrivilegeUuid}
                              label={privilege.privilegeName}
                              value={privilege.privilegeName}
                            >
                              {privilege.privilegeName}
                            </ButtonMenu.Item>
                          ))}
                        </ButtonMenu.Menu>
                      </ButtonMenu>
                      <Button
                        icon="close"
                        size="medium"
                        type="tertiary"
                        onClick={() => onRemove(
                          user.grantee_uuid,
                          user.grantee_type
                        )}
                      />
                    </UserActions>
                  </UserItem>
                ))
              )}
            </UsersListContainerInternal>
          </UsersListContainerExternal>
        </UsersListScrollWrapper>
      )}
    </CollapsibleContainer>
  );
};

export default CurrentUsersList;

